import { MenuData } from "../../model/menu.model";

export const menuData: MenuData[] = [
    {
        id: "screenReader",
        icon: "advancedScreenReader",
        text: "Use a screen reader",
        isShow: true
    },
    {
        id: "keyboardNav",
        icon: "keyboardNav",
        text: "Navigate by keyboard",
        isShow: true
    },
    {
        id: "contrast",
        icon: "lowVision",
        text: "Change color contrast",
        isShow: true
    },
    {
        id: "grayscale",
        icon: "colorBlind",
        text: "Make grayscale",
        isShow: true
    },
    {
        id: "epilepsy",
        icon: "epilepsy",
        text: "Stop moving element",
        isShow: true
    },
    {
        id: "magnify",
        icon: "magnifyScreen",
        text: "Magnify the screen",
        isShow: true
    },
    {
        id: "helpLayer",
        icon: "helpLayer",
        text: "Provide a help layer",
        isShow: false
    },
    {
        id: "voiceControl",
        icon: "voiceControl",
        text: "Voice control",
        isShow: false
    }
]
